import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  root: {
    [theme.breakpoints.down("sm")]: {
      boxShadow: "none",
      backgroundColor: "transparent"
    },
    [theme.breakpoints.up("md")]: {
      height: 420,
      display: "flex",
      flexDirection: "column"
    }
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 12,
    [theme.breakpoints.up("md")]: {
      height: 42,
      padding: "0 16px",
      borderBottom: `1px solid ${theme.palette.text.hint}`,
      marginBottom: 0
    },
    [theme.breakpoints.up("xl")]: {
      fontSize: 14
    }
  },
  headerTitle: {
    fontSize: 16,
    color: "#595a5a"
  },
  headerLink: {
    display: "flex",
    alignItems: "center",
    color: theme.palette.text.secondary,
    fontSize: 14
  },
  headerLinkText: {
    [theme.breakpoints.up("md")]: {
      display: "none"
    }
  },
  headerIcon: {
    fontSize: 13,
    color: theme.palette.text.secondary,
    marginLeft: 10,
    [theme.breakpoints.up("md")]: {
      fontSize: 17
    }
  },
  events: {},
  list: {
    listStyle: "none",
    padding: 0,
    margin: 0
  },
  item: {
    display: "flex",
    justifyContent: "space-between",
    "&:first-child": {
      "& $date": {
        color: "#222222"
      },
      "& day": {
        color: theme.palette.text.secondary
      },
      "& $schedule:before": {
        background: "#222222",
        borderColor: "#222222"
      },
      "& $schedule:after": {
        top: "50%",
        height: "50%"
      }
    },
    "&:last-child": {
      "& $schedule:after": {
        bottom: "50%",
        height: "50%"
      }
    }
  },
  schedule: {
    width: 90,
    paddingLeft: 18,
    position: "relative",
    "&:before": {
      content: '""',
      display: "block",
      width: 9,
      height: 9,
      borderRadius: "50%",
      border: "1px solid #7f7f7f",
      position: "absolute",
      left: 0,
      top: "50%",
      transform: "translate(0, -50%)",
      zIndex: 1,
      background: "#f6fbfa",
      marginTop: "-7px"
    },
    "&:after": {
      content: '""',
      display: "block",
      width: 1,
      height: "100%",
      background: "#7f7f7f",
      position: "absolute",
      left: 4,
      top: 0,
      marginTop: "-7px"
    }
  },
  scheduleOneItem: {
    "&:after": {
      display: "none"
    }
  },
  date: {
    display: "block",
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    fontSize: 14,
    textTransform: "uppercase",
    color: theme.palette.text.secondary,
    paddingTop: 14
  },
  day: {
    display: "block",
    fontSize: 11,
    color: theme.palette.text.hint,
    lineHeight: 1
  },

  details: {
    minHeight: 50,
    flex: 1,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 14,
    padding: "0 12px 0 16px",
    position: "relative",
    overflow: "hidden",

    "&:before": {
      content: '""',
      width: 4,
      position: "absolute",
      left: 0,
      top: 0,
      bottom: 0,
      backgroundColor: "#AFB1B1"
    }
  },
  detailsActions: {
    color: "#333333"
  },
  activityName: {
    display: "block",
    fontSize: 14,
    color: theme.palette.text.primary
  },
  activityFacility: {
    display: "block",
    fontSize: 12,
    color: theme.palette.text.secondary
  },
  calendar: {
    paddingBottom: 16,
    flexGrow: 1,
    display: "flex",
    flexDirection: "column"
  },
  calendarMonthPicker: {
    height: 36,
    padding: "0 16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    [theme.breakpoints.up("xl")]: {
      height: 42
    }
  },
  calendarMonth: {
    fontSize: 12,
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    flexGrow: 1,
    [theme.breakpoints.up("xl")]: {
      fontSize: 14
    }
  },
  calendarMonthControl: {
    marginLeft: 12
  },
  calendarMonthControlIcon: {
    fontSize: 20
  },
  calendarDayNames: {
    display: "flex",
    justifyContent: "space-between",
    paddingLeft: 16,
    paddingRight: 16,
    [theme.breakpoints.up("xl")]: {
      justifyContent: "space-around"
    }
  },
  calendarDayName: {
    width: 23,
    textAlign: "center",
    fontSize: 11,
    color: theme.palette.text.secondary,
    lineHeight: "normal"
  },
  calendarRowsWrapper: {
    minHeight: 160,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    flexGrow: 1
  },
  calendarDates: {
    paddingLeft: 16,
    paddingRight: 16,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexBasis: "20%",
    [theme.breakpoints.up("xl")]: {
      justifyContent: "space-around"
    }
  },
  calendarDateButton: {
    minWidth: 23,
    width: 23,
    height: 23,
    padding: 0,
    color: theme.palette.text.secondary,
    cursor: "default",
    pointerEvents: "none",
    fontSize: 12
  },
  calendarDate: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 18,
    height: 18,
    textAlign: "center",
    color: theme.palette.text.secondary,
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    fontSize: 12,
    [theme.breakpoints.up("xl")]: {
      fontSize: 14
    }
  },
  calendarDateEvent: {
    position: "relative",
    cursor: "pointer",
    color: theme.palette.text.primary,
    pointerEvents: "unset",
    fontWeight: "bold",
    "&:after": {
      position: "absolute",
      width: 6,
      height: 6,
      borderRadius: "50%",
      bottom: "-8px",
      content: "''",
      [theme.breakpoints.up("xl")]: {
        bottom: "-2px"
      }
    }
  },
  disabledCalendarEvent: {
    pointerEvents: "none",
    cursor: "default",
    color: theme.palette.text.secondary,
    fontWeight: "normal"
  },
  calendarDateDisabled: {
    color: "#eeeeee"
  },
  outsideCurrentMonths: {
    color: theme.palette.text.hint
  },
  calendarDateToday: {
    color: theme.palette.text.primary,
    fontWeight: "bold",
    boxShadow: "inset 0 0 0 1px black",
    borderRadius: 3,
    "&:after": {
      bottom: "-7px"
    }
  },
  popover: {
    width: "100%"
  },
  popoverHeader: {
    height: 44,
    paddingLeft: 16,
    paddingRight: 16,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  },
  popoverDate: {
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    fontSize: 16,
    color: theme.palette.text.primary,
    textTransform: "uppercase"
  },
  popoverDayName: {
    fontSize: 16,
    color: theme.palette.text.secondary
  },
  popoverBody: {
    minHeight: 70,
    padding: 16
  },
  popoverActionButtons: {
    padding: "21px 16px"
  },
  popoverHorseName: {
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    fontSize: 16,
    lineHeight: "17px",
    marginBottom: 6
  },
  popoverEventLine: {
    display: "flex",
    alignItems: "center"
  },
  popoverEventFacilityMarker: {
    marginRight: 8
  },
  popoverEvent: {
    fontSize: 14
  },
  addOrEditButton: {
    display: "flex",
    textTransform: "none",
    alignItems: "center",
    justifyContent: "flex-start",
    color: theme.palette.text.primary,
    width: "100%",
    padding: 0
  },
  addOrEditButtonIcon: {
    fontSize: 20,
    padding: 0,
    marginRight: 10
  }
}));
